import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCollectionInfoByIds = {
  name: "getCollectionInfoByIds" as const,
  input: z.object({ collectionIds: z.array(z.string()) }),
  output: z.object({
    collections: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        kind: createEnum(["custom", "smart"]),
      }),
    ),
  }),
};
